import React, { useState, useEffect } from "react";
import List from "../../../../styledComponents/Table/List";
import menuIcon from "../../../../../assets/images/DeathModuleNew/Menu.png";
import plaidIcon from "../../../../../assets/images/budget/plaidlogo.png";
import { Icon } from "antd";
import moment from "moment";
import Tab, { TabItem } from "../../Recurring/RecurringTabs/Tabs";
import { Table } from "antd";

export const UnCategorized = (props) => {
  const [dropdown, setDropdown] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const onTabSelected = (index) => {
    const selectedTabName = getTabNameByIndex(index);
    setSelectedTab(selectedTabName);
    setSelectedIndex(index);
  };
  // const totalAmount =
  // props.transactions &&
  // props.transactions.nullCategoryDataNullCategory &&
  // props.transactions.nullCategoryDataNullCategory.reduce((total, item) => {
  //   return total + item.amount;
  // }, 0);
  const totalAmount =
    props.transactions &&
    props.transactions.nullCategoryDataNullCategory &&
    props.transactions.nullCategoryDataNullCategory.reduce((total, item) => {
      if (selectedTab && selectedTab === "All") {
        // Sum amounts for all items
        return total + item.amount;
      } else if (selectedTab && selectedTab === item.accountName) {
        // Sum amounts only for items with the matching account name
        return total + item.amount;
      } else {
        // Skip items that do not match the selected tab
        return total;
      }
    }, 0);
  const getTabNameByIndex = (index) => {
    if (index >= 0 && index < filteredTabs.length) {
      return filteredTabs[index];
    } else {
      return null;
    }
  };
  const updateBanksData = (banksData) => {
    const new_banksData = [];
    if (banksData) {
      for (const data of banksData) {
        if (data.accountName) {
          // Check if bankName exists
          new_banksData.push({
            ...data,
            // tabName: data.bankName + " " + data.accountType,
            tabName: data.accountName,
          });
        } else {
          new_banksData.push(data);
        }
      }
      return new_banksData;
    }
  };

  // const updatedBanksData = updateBanksData(
  //   props.transactions &&
  //     props.transactions.nullCategoryDataNullCategory &&
  //     props.transactions.nullCategoryDataNullCategory
  // );

  const updatedBanksData = updateBanksData(
    props.filterData
      ? props.filterData
      : props.transactions && props.transactions.nullCategoryDataNullCategory
      ? props.transactions.nullCategoryDataNullCategory
      : []
  );

  const filteredTabs = [
    "All",
    ...new Set(
      updatedBanksData && updatedBanksData.map((item) => item.tabName)
    ),
  ];
  const filterDataByTab = () => {
    if (updatedBanksData && selectedTab) {
      let data;
      if (selectedTab === "All") {
        data = updatedBanksData;
      } else {
        data = updatedBanksData.filter((item) => item.tabName === selectedTab);
      }
      setSelectedData(data);
    }
  };
  useEffect(() => {
    if (props.filterData && props.searchQuery) {
      setSelectedData(props.filterData);
    } else if (selectedTab && selectedTab !== "All") {
      filterDataByTab();
    } else if (
      props.transactions &&
      props.transactions.nullCategoryDataNullCategory
    ) {
      setSelectedData(props.transactions.nullCategoryDataNullCategory);
    } else {
      setSelectedData([]);
    }
  }, [selectedTab, props.state, props.filterData, props.transactions]);
  const userRole = localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client";
  const cols = [
    {
      title: "Date",
      dataIndex: "date",
      // sorter: (a, b) => a["date"] > b["date"],
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
      // render: (record) =>
      //   record ? moment.utc(record).format("MM-DD-YYYY") : "N/A",
      render: (fileName, record) => {
        return record.pending ? (
          <div style={{ background:"#09A84D",padding:"4px",color:"white",display:"flex", justifyContent:"center",borderRadius:"4px",fontWeight:"bold" }}>
            Pending
          </div>
        ) : (
          record.date ? moment.utc(record.date).format("MM-DD-YYYY") : "N/A"
        );
      },
    },
    {
      title: "Item",
      dataIndex: "itemName",
      // sorter: (a, b) => a["itemName"] > b["itemName"],
      sorter: (a, b) => (a.itemName || "").localeCompare(b.itemName || ""),
      render: (fileName, record) => {
        return record.itemName ? (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img
              style={{ borderRadius: "50%" }}
              height={34}
              width={34}
              src={record.itemLogo ? record.itemLogo : plaidIcon}
            ></img>
            <div>{record.itemName}</div>
          </div>
        ) : (
          "N/A"
        );
      },
    },

    {
      title: "Category",
      dataIndex: "categoryFromPlaid",
      // sorter: (a, b) => a["categoryFromPlaid"] > b["categoryFromPlaid"],
      sorter: (a, b) =>
        (a.categoryFromPlaid || "").localeCompare(b.categoryFromPlaid || ""),
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.categoryFromPlaid ? (
          <div 
          style={{cursor:"pointer"}}
          onClick={()=>{
            props.handleOpen();
            handleFormDataUpdate(record);
          }}
          >
            <div>{record.categoryFromPlaid}</div>
            {record.subCategory && (
              <span style={{ color: "black" }}>({record.subCategory})</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (fileName, record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            color:
              record.typeOfTransaction === "Expense" || record.amount < 0
                ? "black"
                : "#00A27B",
          }}
        >
          {record.amount
            ? !isNaN(record.amount)
              ? `${
                  "$" +
                    (record.typeOfTransaction === "Expense"
                    ? record.amount < 0
                      ? record.amount.toFixed(2) // Keep negative if already negative
                      : (record.amount * -1).toFixed(2) // Otherwise, make negative
                    : record.typeOfTransaction === "Income"
                    ? record.amount > 0
                      ? record.amount.toFixed(2) // Keep positive if already positive
                      : (record.amount * -1).toFixed(2) // Otherwise, make positive
                    : record.amount < 0
                    ? (record.amount).toFixed(2) // If amount is negative and no type, show as positive
                    : record.amount.toFixed(2)
                  ) // Positive to negative
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }`
              : "N/A"
            : "N/A"}
        </div>
      ),
    },
    {
      title: "Bank",
      dataIndex: "bankName",
      // sorter: (a, b) => a["bankName"] > b["bankName"],
      sorter: (a, b) => (a.bankName || "").localeCompare(b.bankName || ""),
      render: (fileName, record) => {
        return record.bankName ? (
          <div>
          <div>{record.accountName ? `${record.accountName}` : ""}</div>
            {record.accountType && (
              <span style={{ color: "black" }}>{record.accountType}</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Rule Applied",
      dataIndex: "ruleId",
      sorter: (a, b) => (a.ruleId || "").localeCompare(b.ruleId || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      sorter: (a, b) => (a.notes || "").localeCompare(b.notes || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <React.Fragment>
            <div style={{ display: "flex" }} key={index}>
              {" "}
              <img
                style={{ cursor: "pointer", marginRight: "1rem" }}
                src={menuIcon}
                alt="menuIcon"
                height={15}
                width={4}
                onClick={() => {
                  console.log("recode", record);
                  if(userRole){
                  setSelectedItemId(record.id);
                  // getSelectedRowUpdate(record.id);
                  setDropdown(!dropdown);}
                }}
              ></img>{" "}
              {dropdown && selectedItemId === record.id && (
                <React.Fragment>
                  <div
                    onClick={() => {
                      setDropdown(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}
                  ></div>

                  <div class="dropdown" style={{ zIndex: "9999" }}>
                    <ul className="dropdownul">
                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          props.handleHistoryOpen(record.id);
                        }}
                      >
                        History
                      </li>
                      <li
                        className="liHover"
                        style={{opacity :record.ruleId !== null ? "0.3" : "1", cursor: record.ruleId!==null ? "not-allowed" : "pointer", pointerEvents: record.ruleId!==null ? "none" : "",}}
                        onClick={() => {
                          setDropdown(false);
                          props.handleOpen();
                          handleFormDataUpdate(record);
                        }}
                      >
                        Update
                      </li>

                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          props.deleteTransaction(record.id);
                        }}
                      >
                        Delete
                      </li>
                    </ul>
                  </div>
                </React.Fragment>
              )}{" "}
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  const TableData = [
    {
      id: 1,
      date: "January 31, 2024",
      item: "Amazon",
      category: "",
      bank: "Checking",
      amount: "$500",
    },
    {
      id: 2,
      date: "Mar 31, 2024",
      item: "Uber",
      category: "",
      bank: "Saving",
      amount: "$400",
    },
    {
      id: 3,
      date: "April 30, 2024",
      item: "Apple",
      category: "",
      bank: "Investment",
      amount: "$900",
    },
    {
      id: 4,
      date: "December 31, 2024",
      item: "Amazon",
      category: "",
      bank: "Credit Card",
      amount: "$800",
    },
  ];
  const handleFormDataUpdate = (data) => {
    props.handleUpdateFormData(data);
  };
  return (
    <div>
      {" "}
      {filteredTabs && filteredTabs.length > 0 && (
        <div className="TabSection">
          <Tab onTabSelected={onTabSelected} selectedIndex={selectedIndex}>
            {filteredTabs.map((tab, index) => (
              <TabItem key={index}>{tab}</TabItem>
            ))}
          </Tab>
        </div>
      )}
      <div className="subheading">
        Uncategorized{" "}
        <span className="subheading_amount">
          (${" "}
          {totalAmount
            ? `${totalAmount
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "0"}
          )
        </span>
      </div>
      <div className="tableContainer">
        <Table
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: props.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
              console.log("selectedRowKeys:", selectedRowKeys);
              console.log("selectedRows:", selectedRows);
              props.selectedRowsDataKeys(selectedRowKeys);
            },
          }}
          pagination={{
            showSizeChanger: true, // Show the page size changer
            pageSizeOptions: ['10', '20', '50', '100'], // Options for page size
            defaultPageSize: 10, // Default page size
          }}
          columns={cols}
          dataSource={
            selectedData && selectedData.length > 0
              ? selectedData
              : props.transactions
              ? props.transactions.nullCategoryDataNullCategory
              : []
          }
        />
        {/* <List
          cols={cols}
          rows={
            selectedData && selectedData.length > 0
              ? selectedData
              : props.transactions
              ? props.transactions.nullCategoryDataNullCategory
              : []
          }
          // rows={
          //   props.transactions &&
          //   props.transactions.nullCategoryDataNullCategory
          // }
        /> */}
      </div>
    </div>
  );
};
